<template>  
<div>  
    
        <div class="item2 mt-3">
            <b-row>
                <b-col> <legend>2.- UBICACIÓN DEL NUEVO DOMICILIO ELECTORAL</legend>   </b-col>  
            </b-row>
            <hr class="mt-0 mb-0">
            <b-row>
               <b-col>
                    <strong>Ubicaciones <span class="text-danger">(*)</span> </strong> 
                </b-col>  
            </b-row> 
            
            
            <b-row>
                <b-col>
                    nacio:: {{ nacionalidad }}
                    <b-list-group variant="danger" horizontal="md">
                        <b-list-group-item :active="ubicacion=='chile-urbano'"  @click="cambiar('chile-urbano')" class="flex-column align-items-start" href="#" >
                            <div class="d-flex w-100 justify-content-between">
                            <h5 class="mb-1">EN CHILE-URBANO</h5> 
                            </div> 
                            <p class="mb-1">
                            Su domicilio electoral se encuentra ubicado en una ciudad.
                            </p> 
                        </b-list-group-item> 
                        <b-list-group-item :active="ubicacion=='chile-rural'" @click="cambiar('chile-rural')" href="#" class="flex-column align-items-start">
                            <div class="d-flex w-100 justify-content-between">
                            <h5 class="mb-1">EN CHILE-RURAL</h5> 
                            </div> 
                            <p class="mb-1">
                                Su domicilio electoral se encuentra en un territorio con escasa cantidad de habitantes (poblado, localidad, parcela, entre otros).
                            </p> 
                        </b-list-group-item>  
                        <b-list-group-item :disabled="(incorporacion && !nacionalidad ) || ( !incorporacion && registro.nacionalidad != 'CL')" :active="ubicacion=='extranjero'" @click="cambiar('extranjero')" href="#" class="flex-column align-items-start">
                            <div class="d-flex w-100 justify-content-between">
                            <h5 class="mb-1">EN EL EXTRANJERO</h5> 
                            </div> 
                            <p class="mb-1">
                            Su domicilio electoral se encuentra fuera de Chile.
                            </p> 
                        </b-list-group-item> 
                        
                </b-list-group>
                <p class="mb-0 text-danger" v-if="!$v.ubicacion.required">(*) Necesita elegir una ubicación</p>

                </b-col> 
            </b-row> 

            <div v-if="ubicacion != '' " class="mt-3">
            
                <b-row>
                <b-col> <legend>3.- INGRESO DEL NUEVO DOMICILIO ELECTORAL</legend>   </b-col>  
                

                </b-row> 
                <hr class="mt-0 mb-0">

                <div v-if="ubicacion =='chile-urbano'"> 
                    <b-row>
                        <b-col sm="4">
                            <b-form-group label="Región" > 
                                <model-list-select 
                                    autocomplete="nope"
                                    :isError="$v.formChileUrbano.region.$invalid" 
                                    :list="regiones"
                                    v-model="formChileUrbano.region"
                                    option-value="cod_region"
                                    option-text="region" 
                                    placeholder="seleccionar región">
                                </model-list-select>
                                <p v-if="!$v.formChileUrbano.region.required" class="invalid-feedback mb-0">
                                    El región es requerido
                                </p> 
                            </b-form-group>
                        </b-col>   
                        <b-col sm="4">
                            <b-form-group label="Comuna" >
                                <model-list-select 
                                    autocomplete="nope"
                                    :isError="$v.formChileUrbano.comuna.$invalid"
                                    v-model="formChileUrbano.comuna"
                                    :list="comunas"
                                    option-value="cod_comuna"
                                    option-text="comuna" 
                                    placeholder="seleccionar comuna">
                                </model-list-select>  
                            </b-form-group>   
                        </b-col>   
                        <b-col sm="4">
                            <b-form-group label="Villa / Población" > 
                            <vue-bootstrap-typeahead 
                                v-model="formChileUrbano.villa_poblacion"
                                :data="localidades"
                            /> 
                            </b-form-group>  
                        </b-col>  
                    </b-row> 
                    <b-row>
                        <b-col sm="8"> 
                              <b-form-group label="Calle" > 
                            <b-form-input  
                                autocomplete="nope"
                                :class="{ 'is-invalid': $v.formChileUrbano.calle.$invalid }"
                                v-model="formChileUrbano.calle" 
                                type="text"
                                placeholder="Calle"
                                required
                                ></b-form-input>
                                  <p v-if="!$v.formChileUrbano.calle.maxLength" class="invalid-feedback mb-0">
                                El maximo permitido es de 200 caracteres 
                            </p> 
                            </b-form-group>    
                        </b-col>
                        <b-col sm="4">
                            <b-form-group label="Número" > 
                            <b-form-input 
                                autocomplete="nope"
                                v-model="formChileUrbano.numero" 
                                type="text"
                                placeholder="ej: 0000 "
                                required
                                ></b-form-input>
                            </b-form-group>  

                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group label="Block / Departamento" > 
                            <b-form-input
                                autocomplete="nope" 
                                v-model="formChileUrbano.block_depto" 
                                type="text"
                                placeholder="Nombre del Block / Departamento"
                                :class="{ 'is-invalid': $v.formChileUrbano.block_depto.$invalid }"
                                required
                                ></b-form-input> 
                            <p v-if="!$v.formChileUrbano.block_depto.maxLength" class="invalid-feedback mb-0">
                                El maximo permitido es de 110 caracteres 
                            </p> 
                            </b-form-group>   
                        
                        </b-col> 
                    </b-row>
                   
                </div> 
 
                <div v-if="ubicacion =='chile-rural'">
                    <b-row>
                        <b-col sm="4">
                            <b-form-group label="Región" >
                                <model-list-select
                                    autocomplete="nope" 
                                    :isError="$v.formChileRural.region.$invalid"
                                    v-model="formChileRural.region"
                                    :list="regiones"
                                    option-value="cod_region"
                                    option-text="region" 
                                    placeholder="seleccionar región">
                                </model-list-select>  
                            </b-form-group>
                        </b-col>   
                        <b-col sm="4">
                            <b-form-group label="Comuna" > 
                                <model-list-select
                                    autocomplete="nope" 
                                    :isError="$v.formChileRural.comuna.$invalid"
                                    v-model="formChileRural.comuna"
                                    :list="comunas"
                                    option-value="cod_comuna"
                                    option-text="comuna" 
                                    placeholder="seleccionar comuna">
                                </model-list-select>   
                            </b-form-group>  
                        </b-col>   
                        <b-col sm="4"> 
                            <b-form-group label="Localidad" > 
                                <vue-bootstrap-typeahead 
                                v-model="formChileRural.localidad"
                                :data="localidades"
                                />  
                            </b-form-group>  
                        </b-col>   
                    </b-row>
                    <b-row>
                        <b-col sm="8"> 
                            <b-form-group label="Calle / Parcela / Sitio / Carretera-KM" > 
                            <b-form-input 
                                autocomplete="nope"
                                :class="{ 'is-invalid': $v.formChileRural.calle.$invalid }"
                                v-model="formChileRural.calle" 
                                type="text"
                                placeholder="Ingrese Dirección"
                                required
                                ></b-form-input>
                                 <p v-if="!$v.formChileRural.calle.maxLength" class="invalid-feedback mb-0">
                                    El maximo permitido es de 200 caracteres 
                                </p> 
                                <p v-if="!$v.formChileRural.calle.required" class="invalid-feedback mb-0">
                                    El campo es requerido
                                </p> 
                            </b-form-group>  
                        </b-col>
                        <b-col sm="4">
                            <b-form-group label="Número" > 
                            <b-form-input
                                autocomplete="nope" 
                                v-model="formChileRural.numero" 
                                type="text"
                                placeholder="ej: 0000 "
                                required
                                ></b-form-input>
                            </b-form-group>  
                        </b-col>
                    </b-row>
                </div> 

                 <div v-if="ubicacion =='extranjero'">
                    <b-row>
                        <b-col sm="4">
                            <b-form-group label="País" >
                                <model-list-select
                                    autocomplete="nope" 
                                    :isError="$v.formExtranjero.pais.$invalid"
                                    v-model="formExtranjero.pais"
                                    :list="paises"
                                    option-value="cod_pais"
                                    option-text="pais" 
                                    placeholder="seleccionar pais">
                                </model-list-select>   
                            </b-form-group>
                        </b-col>   
                        <b-col sm="4">
                            <b-form-group label="División Territorial" > 
                                <model-list-select 
                                    autocomplete="nope"
                                    :isError="$v.formExtranjero.division_territorial.$invalid"
                                    v-model="formExtranjero.division_territorial"
                                    :list="territorios"
                                    option-value="cod_region"
                                    option-text="region" 
                                    placeholder="seleccionar territorio">
                                </model-list-select>   
                            </b-form-group>  
                        </b-col>   
                        <b-col sm="4">
                            <b-form-group label="Ciudad" >
                                <model-list-select 
                                    autocomplete="nope"
                                    :isError="$v.formExtranjero.ciudad.$invalid"
                                    v-model="formExtranjero.ciudad"
                                    :list="ciudades"
                                    option-value="cod_comuna"
                                    option-text="comuna" 
                                    placeholder="seleccionar ciudad">
                                </model-list-select>   
                            </b-form-group>  
                        </b-col>   
                    </b-row>
                    <b-row>
                        <b-col sm="8"> 
                            <b-form-group label="Calle" > 
                            <b-form-input  
                                :class="{ 'is-invalid': $v.formExtranjero.calle.$invalid }"
                                autocomplete="nope"
                                v-model="formExtranjero.calle" 
                                type="text"
                                placeholder="Calle"
                                required
                                ></b-form-input>
                                <p v-if="!$v.formExtranjero.calle.maxLength" class="invalid-feedback mb-0">
                                El maximo permitido es de 200 caracteres 
                            </p> 
                            </b-form-group>  
                   
                        </b-col>
                        <b-col sm="4">
                            <b-form-group label="Número" > 
                            <b-form-input
                                autocomplete="nope"
                                v-model="formExtranjero.numero" 
                                type="text"
                                placeholder="ej: 0000 "
                                required
                                ></b-form-input>
                            </b-form-group>  
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="4"> 
                            <b-form-group label="Código Postal" > 
                            <b-form-input 
                                autocomplete="nope"
                                v-model="formExtranjero.codigo_postal" 
                                type="text"
                                placeholder="ej: 0000 "
                                required
                                ></b-form-input>
                            </b-form-group>  
                        </b-col>
                        <b-col sm="8">
                            <b-form-group label="Block / Departamento" > 
                            <b-form-input 
                                autocomplete="nope"
                                v-model="formExtranjero.block_depto" 
                                type="text"
                                placeholder="Nombre del Block / Departamento"
                                required
                                ></b-form-input>
                            </b-form-group>  
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="4"> 
                            <b-form-group label="Circunscripción" >
                                <model-list-select 
                                    ref="circuncripcion"
                                    :isError="$v.formExtranjero.circunscripcion.$invalid"
                                    v-model="formExtranjero.circunscripcion"
                                    :list="circunscripciones"
                                    option-value="cod_circunscripcion"
                                    option-text="circunscripcion" 
                                    placeholder="seleccionar circuncripcion">
                                </model-list-select>  
                            </b-form-group>   
                        </b-col>
                    </b-row> 
                 </div>   
             <b-row>
                        <b-col sm="6">
                            <b-form-group label="Correo Electrónico" > 
                            <b-form-input
                                :class="{ 'is-invalid': $v.formComun.email.$invalid }" 
                                v-model="formComun.email" 
                                type="text"
                                placeholder="Ingresar Email"
                                required
                                ></b-form-input>
                                <p v-if="!$v.formComun.email.maxLength" class="invalid-feedback mb-0">
                                    El maximo permitido es de 50 caracteres 
                                </p> 
                                <p v-if="!$v.formComun.email.required" class="invalid-feedback mb-0">
                                    El correo es requerido
                                </p> 
                                <p v-if="!$v.formComun.email.email" class="invalid-feedback mb-0">
                                    Formato de correo incorrecto
                                </p> 
                            </b-form-group>   
                        </b-col>
                    <b-col sm="6">
                        <b-form-group label="Confirmar Correo Electrónico" > 
                        <b-form-input 
                            :class="{ 'is-invalid': $v.formComun.email2.$invalid }"
                            v-model="formComun.email2" 
                            type="text"
                            placeholder="Ingresar Email"
                            required
                            ></b-form-input>
                            <p v-if="!$v.formComun.email2.required" class="invalid-feedback mb-0">
                                Confirmar correo es requerido
                            </p> 
                            <p v-if="!$v.formComun.email2.email" class="invalid-feedback mb-0">
                                Formato de correo incorrecto
                            </p>
                            <p v-if="!$v.formComun.email2.sameAs" class="invalid-feedback mb-0">
                                Los correos no son iguales
                            </p> 
                          
                        </b-form-group>   
                    </b-col>
                </b-row>  
                <b-row>
                    <b-col sm="6">
                        <b-form-group label="Teléfono" > 
                            <b-form-input 
                                :class="{ 'is-invalid': $v.formComun.telefono.$invalid }"
                                v-model="formComun.telefono" 
                                type="text"
                                placeholder="ej:+56 2 2222222"
                                required>
                            </b-form-input>
                            <p v-if="!$v.formComun.telefono.required" class="invalid-feedback mb-0">
                                El Teléfono es requerido
                            </p>   
                            <p v-if="!$v.formComun.telefono.maxLength" class="invalid-feedback mb-0">
                                    El maximo permitido es de 10 caracteres 
                            </p> 
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row v-if="ubicacion=='chile-urbano' || ubicacion=='chile-rural'">
                    <b-col>
                        <b-form-group label="Notificación">
                            <b-form-checkbox 
                            v-model="formChileUrbano.notificacion_correo"
                            name="notificacion_correo"
                            value="true"
                            unchecked-value="false"
                            :checked="formChileUrbano.notificacion_correo"
                            >
                            Solicito que la notificación del cambio de domicilio electoral se envíe a mi correo electrónico
                            </b-form-checkbox>
                        </b-form-group>
                    </b-col>
                </b-row> 

                 <b-row> 
                    <b-col> 
                        <b-form-group>
                            <b-button v-if="ubicacion == 'chile-urbano'" :disabled="($v.formChileUrbano.$invalid || $v.formComun.$invalid || otrasValidaciones)" @click="sendToForm()" block variant="primary">Enviar</b-button>
                            <b-button v-if="ubicacion =='chile-rural'" :disabled="($v.formChileRural.$invalid || $v.formComun.$invalid || otrasValidaciones)" @click="sendToForm()" block variant="primary">Enviar</b-button>
                            <b-button v-if="ubicacion =='extranjero'" :disabled="($v.formExtranjero.$invalid || $v.formComun.$invalid || otrasValidaciones || ( !incorporacion && registro.nacionalidad != 'CL'))" @click="sendToForm()" block variant="primary">Enviar</b-button>
                        </b-form-group>
                    </b-col>
                </b-row>   
            </div>   
        </div>  
        

</div> 
</template>

 
<script>  

import { required, email, sameAs, maxLength } from 'vuelidate/lib/validators'  
import { ModelListSelect  } from 'vue-search-select' 
import { format }  from 'rut.js' 
import { mapState, mapActions } from "vuex" 

     

const computed = {
    ...mapState('registro', ['registro']), 
    ...mapState('domicilio', ['ubicacion']), 
    ...mapState('domicilio', ['formChileUrbano']), 
    ...mapState('domicilio', ['formChileRural']), 
    ...mapState('domicilio', ['formExtranjero']),
    ...mapState('domicilio', ['formComun']), 
     
    ...mapState('domicilio', ['regiones']), 
    ...mapState('domicilio', ['comunas']), 
    ...mapState('domicilio', ['paises']), 
    ...mapState('domicilio', ['ciudades']), 
    ...mapState('domicilio', ['territorios']), 
    ...mapState('domicilio', ['circunscripciones']), 
    ...mapState('domicilio', ['localidades']), 
    ...mapState('mapa', ['domicilios', 'calles'])
     
} 

const watch =  { 
       
        'formComun.email': async function(val)
        {
            if(!val) return
            

            this.formComun.email = String(val).toLowerCase()

        },
        'formComun.email2': async function(val)
        {
            if(!val) return
            

            this.formComun.email2 = String(val).toLowerCase()

        },
        'formChileUrbano.region': async function(val)
        {
            if(!val) return

            await this.getComunas(val)
        },
        'formChileRural.region': async function(val)
        {
            if(!val) return

            await this.getComunas(val)
        },
        'formExtranjero.pais': async function(val)
        {
            if(!val) return

            await this.getTerritorios(val)
        },
        'formExtranjero.division_territorial': async function(val)
        {
            if(!val) return

            await this.getCiudad(val)
        },
        'formExtranjero.ciudad': async function(val)
        {
            if(!val) return

            await this.getCircuncripciones(val)
            await this.setCalles([])
        },
        'formChileUrbano.comuna': async function(val)
        {
            if(!val) return

            this.cod_comuna = val
            await this.getLocalidad(val) 
            await this.setCalles([])
      
        },
        'formChileRural.comuna': async function(val)
        {
            if(!val) return

            await this.getLocalidad(val)
           
        },
        'ischile': async function(val)
        {

            this.cambiar('')

        }
    }


export default {
    name: "Solicitar",
    props: ['ischile', 'incorporacion', 'otrasValidaciones', 'nacionalidad'],
    components: {  
        ModelListSelect, 
        // MapaDireccion ,
        // MapaPosicion
    }, 
    computed,
    watch,
    data: function () {
    return { 
        cod_comuna: null,
        loading : true, 
        domicilioSearch: '', 
        calleSearch: '', 
        selectedCalle : '' ,
        selectedDomicilio : '' ,
        key: 'PAK-EqJXINwlBJx2xI2teKbXyBiJ2vpic7WanAwkl1g',

        }
    },
    validations :{  
        ubicacion: { required },
        formComun: {
            email : { required, email, maxLength: maxLength(50) },
            email2 : { required, email, sameAs: sameAs('email') },
            telefono : {  required, maxLength: maxLength(10) } 
        },
        formChileUrbano : {
            region: { required },
            comuna: { required },
            calle: { required, maxLength: maxLength(200) },
            block_depto : { maxLength: maxLength(110) } 

        },
        formChileRural : {
            region: { required },
            comuna: { required },
            calle: { required, maxLength: maxLength(200) },

        },
        formExtranjero : {
            pais: { required },
            division_territorial: { required },
            ciudad: { required },
            calle: { required, maxLength: maxLength(200) },
            circunscripcion: { required },
        }

    }, 
    async mounted()
    { 
        
        await Promise.all([this.getRegiones('CL'), this.getPaises()])  
 

         let email = ''
        if(this.registro && this.registro.email)
        {
            email = this.registro.email.toLowerCase() 
            this.formComun.email = email
            this.formComun.email2 = email

        }  
        
    },
    methods: { 

        ...mapActions('mapa', ['setDomicilios', 'setCalles']), 
         ...mapActions('domicilio', ['changeUbicacion']), 
         ...mapActions('domicilio', [
             'getLocalidad',
             'getPaises',
             'getTerritorios',
             'getCiudad',
             'getCircuncripciones',
             'getComunas',
             'getRegiones',
             ]), 

        formatDireccion()
        {
            let domicilio = ''

            if(this.registro.calle) domicilio = `${ this.registro.calle}`
            if(this.registro.numero) domicilio += ` ${ this.registro.numero}`
            if(this.registro.resto) domicilio += ` ${ this.registro.resto}`
            if(this.registro.nombre_comuna) domicilio += `, ${ this.registro.nombre_comuna}`
            if(this.registro.nombre_region) domicilio += `, ${ this.registro.nombre_region}`

            domicilio+= ` CIRCUNSCRIPCIÓN : ${ this.registro.nombre_circuns }`

            return domicilio

        },
        formatNombre()
        {
            let nombre = ``

            if(this.registro.paterno) nombre += this.registro.paterno
            if(this.registro.materno) nombre += ' '+ this.registro.materno
            if(this.registro.nombres) nombre += ' '+ this.registro.nombres 

            return nombre

        },
        formatRun()
        {
            return format(`${this.registro.cedula}-${this.registro.dv}`)

        },
        async cambiar(ubicacion)
        {

            await this.changeUbicacion(ubicacion) 
            if(ubicacion == 'extranjero')
            {
                // const ref = this.$refs.circuncripcion.$children[0].$refs.input
                // ref.setAttribute("autocomplete", "nope") 

            }
            if(ubicacion == 'chile-urbano')
            {
                // const ref = this.$refs.chileurbanoCalle.$refs.input

                // ref.setAttribute("autocomplete", "nope")  

            }
        },
         

        async sendToForm()
        {
            this.$emit('sendToForm')
        },
    }
}
</script>

<style>
</style>
